import { render } from "./EasyOverseasPaymentPage.vue?vue&type=template&id=ff3ef504"
import script from "./EasyOverseasPaymentPage.vue?vue&type=script&lang=js"
export * from "./EasyOverseasPaymentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__